// angular
import { Injectable, signal } from '@angular/core';
// interfaces & types
import { IMessage } from '@app/+chat/shared/interfaces';
import { IChat } from '../interfaces/chat.interface';
import { IEmploysPeople } from '../interfaces/member.interface';
import { IBusiness } from '@app/+suppliers/shared/interfaces/business.interface';
import { FireBaseDataType } from '@app/shared/types/firebase-data-type';
import { MessagePayload } from 'firebase/messaging';
import { AlertStatesEnum } from '../enums/alert-states.enum';

@Injectable()
export class StateManagementService {
  // translation
  public currentChatLanguage = signal<string>('');
  // toggle chat box
  public isChatBoxOpen = signal<boolean>(false);
  // business data states
  public businessId = signal<string>('');
  public businessChatData = signal<IBusiness>({});
  // chats global states
  public isChatLoading = signal<boolean>(false);
  public isCreateChatLoading = signal<boolean>(false);
  public oneChatById = signal<IChat | null>(null);
  public isChatExist = signal<boolean>(false);
  public isError = signal<boolean>(false);
  public errorMessage = signal<unknown>(null);
  public chatAlertState = signal<AlertStatesEnum>(AlertStatesEnum.publicChat);
  // messages global state
  public allMessages = signal<IMessage[]>([]);
  public allMessagesCount = signal<number | null>(null);
  public messagesCurrentPage = signal<number>(0);
  public messagesAllPages = signal<number>(0);
  public isMessagesLoading = signal<boolean>(false);
  public oneMessage = signal<IMessage | null>(null);
  public isEditMessageMod = signal<boolean>(false);
  public editMessageContent = signal<IMessage | null>(null);
  public selectedSuggestionMessage = signal<string>('');

  // members global state
  public projectEmploysPeoples = signal<IEmploysPeople[]>([]);
  // firebase data
  public firebaseData = signal<FireBaseDataType | null>(null);
  // notifications data
  public messagesNotifications = signal<MessagePayload[]>([]);
}
